// extracted by mini-css-extract-plugin
export default {"modalFooter":"ModalFooter-modalFooter-wjkx5"};